angular.module('impactx.stockwithdrawal').controller('StockWithdrawalOpenListCtrl', [
    "selectedListItems",
    StockWithdrawalOpenListController
]);

function StockWithdrawalOpenListController(selectedListItems) {
    var self = this;

    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: canEditStockWithdrawal,
            process: 'ViewStockWithdrawal'
        }
    ];

    self.meta = {
        rowTemplate: 'modules/stockwithdrawal/templates/stock-withdrawal-list-open.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/stockwithdrawal/list/open',
        id: "stockwithdrawalopen",
        buttonDefinition: buttonDefinition
    };

    self.getMeta = function () {
        return self.meta;
    };

    function getDetailLink() {
        return "stockwithdrawal/" + "0/" + selectedListItems.getFirstSelectedId();
    }

    function canEditStockWithdrawal() {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canEdit.value;
    }
}